import React, { Component } from "react";
import SisanjeBradaServiceImage from "../../images/icon-service-4-70x62.png"
import Barber1Image from "../../images/barber1.jpg"
import Barber2Image from "../../images/barber2.jpg"

class BookingBarberChoiceComponent extends Component {

    render() { 
        return (  
        <section className="section-xl bg-periglacial-blue one-screen-page-content text-center">
        <div className="shell">
          <h2>Izaberite frizera</h2>
      
          <div className="range range-50">
            <div className="cell-xs-12 cell-md-2">
            </div>
            <div className="cell-xs-12 cell-md-12">
              <article className="card-service-option"><img className="card-service-option-image"
                  src={Barber1Image} alt="" width="270" height="360" />
                <p className="card-service-option-title">Jovan</p>
                <div className="card-service-option-panel">
                  <span className="btn btn-xs card-service-option-control" 
                    onClick={() => this.props.onBarberChoice('frizer1')}>Izaberite</span>
                </div>
              </article>
            </div>
            {/* <div className="cell-xs-12 cell-md-4">
              <article className="card-service-option"><img className="card-service-option-image"
                  src={Barber2Image} alt="" width="270" height="360" />
                <p className="card-service-option-title">Aleksandar</p>
                <div className="card-service-option-panel">
                  <span className="btn btn-xs card-service-option-control"
                   onClick={() => this.props.onBarberChoice('frizer2')}>Izaberite</span>
                </div>
              </article>
            </div> */}
            <div className="cell-xs-12 cell-md-2">
            </div>
          </div>
        </div>
      </section>
      );
    }
}
 
export default BookingBarberChoiceComponent;